/** Мост к десктопному приложению (Electron). В обычном браузере всё это отсутствует. */
export interface DesktopItem { id: string; text: string; at: number; error?: string }
export interface DesktopStatusData {
  version: string;
  online: boolean;
  syncing: boolean;
  prefetching: boolean;
  authRequired: boolean;
  /** связи нет дольше часа — пора раздать интернет и выгрузить данные */
  stale?: boolean;
  lastContact?: number;
  pending: DesktopItem[];
  failed: DesktopItem[];
  lastSync: number | null;
  update: { state: "idle" | "checking" | "downloading" | "ready" | "error"; version: string | null; progress: number; error: string | null };
  latestVersion: string | null;
  updateNotes: string | null;
  mustUpdate: boolean;
}

export type PrintCategory = "label" | "a4" | "receipt";
export interface PrintCfg { printer: string; auto: boolean; copies: number; orientation?: "" | "portrait" | "landscape" }
export type PrintSettings = Record<PrintCategory, PrintCfg>;

export interface DesktopApi {
  isDesktop: true;
  serverOrigin: string;
  getStatus(): Promise<DesktopStatusData>;
  onStatus(fn: (s: DesktopStatusData) => void): () => void;
  syncNow(): Promise<unknown>;
  retryFailed(id?: string): Promise<unknown>;
  discardFailed(id?: string): Promise<unknown>;
  listPrinters(): Promise<{ name: string; isDefault: boolean }[]>;
  getPrintSettings(): Promise<PrintSettings>;
  setPrintSettings(s: PrintSettings): Promise<PrintSettings>;
  print(base64: string, category: PrintCategory): Promise<{ ok: boolean; error?: string; printer?: string }>;
  checkUpdates(): Promise<unknown>;
  installUpdate(): Promise<{ ok: boolean; error?: string }>;
}

export const desktop: DesktopApi | undefined = typeof window !== "undefined" ? (window as any).keyoffDesktop : undefined;
export const isDesktop = !!desktop;

/** Адрес сервера для сокетов: в десктопе страница живёт на app://, поэтому берём настоящий адрес */
export const serverOrigin = (): string => desktop?.serverOrigin ?? window.location.origin;
export const serverHost = (): string => new URL(serverOrigin()).host;

export function toast(message: string, kind: "info" | "error" = "info") {
  window.dispatchEvent(new CustomEvent("desktop-toast", { detail: { message, kind } }));
}
